import React from "react";
import { useNavigate } from "react-router-dom";
import { IconCreditCard, IconLoader2 } from "@tabler/icons-react";

/**
 * Grilla de planes de pago. Cada botón navega al checkout unificado con PayPal SDK.
 * Props: packages, lang, loading
 */
export default function PricingGrid({ packages, lang, loading }) {
  const nav = useNavigate();
  if (loading) {
    return <div className="card"><IconLoader2 className="animate-spin" /></div>;
  }

  return (
    <div className="grid sm:grid-cols-2 gap-3 mb-10" data-testid="pricing-grid">
      {packages.map((pkg) => {
        const isRecurring = pkg.kind === "recurring_monthly";
        const period = pkg.period_label || (isRecurring ? "monthly" : "one_time");
        const periodTagES = period === "monthly" ? "Mensual" : period === "yearly" ? "Anual" : "Pago único";
        const periodTagEN = period === "monthly" ? "Monthly" : period === "yearly" ? "Yearly" : "One-time";
        const periodTag = lang === "es" ? periodTagES : periodTagEN;
        const periodSuffixES = period === "monthly" ? "/ mes" : period === "yearly" ? "/ año" : "· pago único";
        const periodSuffixEN = period === "monthly" ? "/ mo" : period === "yearly" ? "/ yr" : "· one-time";
        const periodSuffix = lang === "es" ? periodSuffixES : periodSuffixEN;
        const hasCompare = pkg.compare_amount && pkg.compare_amount > pkg.amount;
        const borderCls =
          period === "monthly" ? "border-l-[4px] border-l-honey" :
          period === "yearly" ? "border-l-[4px] border-l-teal-deep" : "";
        return (
          <div key={pkg.id} className={`card ${borderCls}`} data-testid={`pkg-${pkg.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <h4 className="font-display text-[17px] font-medium">{pkg.name}</h4>
                <p className="text-tert text-[12.5px] mt-1">{pkg.description}</p>
              </div>
              <span className={`tag ${period === "monthly" ? "tag-honey" : ""}`}>{periodTag}</span>
            </div>
            <div className="flex items-end justify-between mt-4 flex-wrap gap-2">
              <div className="flex items-baseline gap-2">
                <span className="font-display text-[28px] font-medium leading-none">${pkg.amount.toFixed(2)}</span>
                {hasCompare && (
                  <span className="text-tert text-[13.5px] line-through" data-testid={`pkg-compare-${pkg.id}`}>${pkg.compare_amount.toFixed(2)}</span>
                )}
                <span className="text-tert text-[11px] uppercase">{pkg.currency}</span>
                <span className="text-tert text-[11.5px]">{periodSuffix}</span>
              </div>
              <button
                className="btn text-[12px]"
                onClick={() => nav(`/app/checkout/package/${pkg.id}`)}
                data-testid={`buy-${pkg.id}`}
              >
                <IconCreditCard size={12} /> {lang === "es" ? "Comprar" : "Buy"}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
